import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Conditions = class Conditions extends VuexModule {
    constructor() {
        super(...arguments);
        this.conditions = [];
        this.cachedVersion = 0;
    }
    async fetchConditions() {
        const { data: conditions, cachedVersion } = await fetchFromCache(this, 'conditions', 'conditions', 'conditionsLU');
        return { conditions, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['conditions', 'cachedVersion'] })
], Conditions.prototype, "fetchConditions", null);
Conditions = __decorate([
    Module({ namespaced: true, name: 'conditions' })
], Conditions);
export default Conditions;
